import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import OSSPod from "../OSSPod/OSSPod";

const styles = theme => ({
  errorHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "10vh"
  },
  errorIcon: {
    color: theme.palette.error.main,
    fontSize: 75,
    opacity: 0.75
  },
  expansionPanel: {
    "&::before": {
      display: "none"
    }
  },
  expansionPanelSummary: {
    padding: 0
  },
  expansionPanelDetails: {
    padding: 0
  }
});

class OSSErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState(
      {
        error: error,
        errorInfo: errorInfo
      },
      () => this.props.onCatch(error, errorInfo)
    );
  }

  render() {
    const { classes, children } = this.props;
    const { error, errorInfo } = this.state;

    if (error && errorInfo) {
      return (
        <OSSPod>
          <OSSPod.Body>
            <div className={classes.errorHeadingContainer}>
              <Icon classes={{ root: classes.errorIcon }}>cancel</Icon>
            </div>
            <ExpansionPanel
              classes={{ root: classes.expansionPanel }}
              elevation={0}>
              <ExpansionPanelSummary
                expandIcon={
                  <IconButton>
                    <Icon>expand_more</Icon>
                  </IconButton>
                }
                classes={{ root: classes.expansionPanelSummary }}>
                <div>
                  <Typography variant="h6" gutterBottom>
                    Ooooops, something went wrong
                  </Typography>
                  <Typography variant="subtitle1">
                    Please try to reload this page. If the problem persists
                    please{" "}
                    <Link
                      to="/"
                      style={{ color: "#2A7CB5", textDecoration: "none" }}>
                      contact us
                    </Link>
                    .
                  </Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                classes={{ root: classes.expansionPanelDetails }}>
                <div style={{ overflow: "auto" }}>
                  <pre>{error.toString()}</pre>
                  <pre>{errorInfo.componentStack.toString()}</pre>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </OSSPod.Body>
        </OSSPod>
      );
    }

    return children;
  }
}

OSSErrorBoundary.propTypes = {
  onCatch: PropTypes.func
};

OSSErrorBoundary.defaultTypes = {
  onCatch: () => null
};

export default withStyles(styles)(OSSErrorBoundary);
